import * as React from 'react';

function SvgCheckmark(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.684 4.229c.384.336.423.92.087 1.303L9.065 20.054a.924.924 0 01-1.349.045l-5.445-5.446a.924.924 0 011.306-1.306l4.748 4.747L20.38 4.316a.924.924 0 011.303-.087z", clipRule: "evenodd" })));
}

export default SvgCheckmark;
